import { getAlgoliaResults } from '@algolia/autocomplete-js';

import { Autocomplete } from './Autocomplete';
import { searchClient } from './searchClient';
import { SearchRounded } from '@mui/icons-material';
import { SearchBoxActivity } from './SearchActivity';

const SearchBoxWithDefaultSuggestions = ({ fixToTop, querySelected, defaultSuggestions, placeholder, initialQuery }) => {
    const containerClassName = fixToTop ?
        'algoliaCustom appSearchBoxDock fixToTop' :
        'algoliaCustom appSearchBoxDock';

    function TopicItem({ hit, components }) {

        const onClick = () => {
            querySelected(hit.name);
        }

        return (
            <button style={{ textAlign: 'left' }} onClick={onClick}>
                <span style={{ verticalAlign: 'middle' }}>
                    <SearchRounded style={{ fontSize: '26px', margin: '0px 6px 0px 8px', verticalAlign: 'middle', color: 'var(--app-text-secondary)' }} />
                </span>
                <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>
                    <components.Highlight hit={hit} attribute="name" />
                </span>
            </button>
        );
    }

    function DefaultQuery({ query }) {

        const onClick = () => {
            querySelected(query);
        }

        return (
            <button style={{ textAlign: 'left' }} onClick={onClick}>
                <span style={{ verticalAlign: 'middle' }}>
                    <SearchRounded style={{ fontSize: '26px', margin: '0px 6px 0px 8px', verticalAlign: 'middle', color: 'var(--app-text-secondary)' }} />
                </span>
                <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>
                    {query}
                </span>
            </button>
        );
    }

    const onSubmit = ({ state }) => {
        querySelected(state?.query ?? '');
    }

    const onReset = () => {
        querySelected('');
    }

    return (
        <div className={containerClassName}>
            <SearchBoxActivity>
                <Autocomplete
                    placeholder={placeholder}
                    openOnFocus={true}
                    onSubmit={onSubmit}
                    onReset={onReset}
                    initialState={{
                        query: initialQuery
                    }}
                    getSources={({ query }) => {
                        if (!query) {
                            return [
                                {
                                    sourceId: 'defaultSuggestions',
                                    getItems() {
                                        return defaultSuggestions.map((suggestion) => ({ query: suggestion }));
                                    },
                                    templates: {
                                        item({ item }) {
                                            return <DefaultQuery query={item.query} />;
                                        },
                                    }
                                },
                            ];
                        }
                        return [
                            {
                                sourceId: 'sourceId',
                                getItems() {
                                    return getAlgoliaResults({
                                        searchClient,
                                        queries: [
                                            {
                                                indexName: 'topics',
                                                query,
                                            },
                                        ],
                                    });
                                },
                                templates: {
                                    item({ item, components }) {
                                        return <TopicItem hit={item} components={components} />;
                                    },
                                },
                            },
                        ];
                    }}
                />
            </SearchBoxActivity>
        </div>
    );
}

export default SearchBoxWithDefaultSuggestions;
